import React, { useEffect } from 'react';
import { Typography, styled, IconButton } from '@mui/material/';
import PropTypes from 'prop-types';
import {
	SearchIcon,
	RecentIcon,
	// SearchPinIcon,
} from '../../assets/icons';

const RecentSearchRow = ({
	item,
	type,
	index,
	handleBookmark,
	color,
	FontFace,
	onClick,
	setPre,
}) => {
	const StyledDiv = styled('div')(({ color }) => ({
		color: color.text.primary,
		'&:hover': {
			backgroundColor: color.button.primary_outline_pressed,
		},
	}));
	useEffect(() => {
		if (typeof setPre === 'function') {
			setPre(true);
		}
	}, [setPre]);

	return (
		<StyledDiv
			key={index}
			color={color}
			className="recentSearchRow"
			onClick={() => {
				onClick(item);
			}}
		>
			{type === 'search' ? (
				<SearchIcon className={'recentIcon'} />
			) : (
				<RecentIcon className={'recentIcon'} />
			)}
			<Typography
				style={{
					fontSize: FontFace.font_size.x_small,
					fontFamily: 'Inter-Regular',
					cursor: 'pointer',
				}}
				onClick={() => {
					onClick(item);
				}}
				onMouseDown={(e) => e.stopPropagation()}
			>
				{item}
			</Typography>
			<IconButton
				onClick={() => handleBookmark(item)}
				style={{ marginLeft: 'auto' }}
			>
				{/* <SearchPinIcon /> */}
			</IconButton>
		</StyledDiv>
	);
};

export default RecentSearchRow;
RecentSearchRow.propTypes = {
	item: PropTypes.string.isRequired,
	index: PropTypes.string.isRequired,
	handleBookmark: PropTypes.func.isRequired,
	color: PropTypes.object.isRequired,
	FontFace: PropTypes.object.isRequired,
	type: PropTypes.string.isRequired,
	onClick: PropTypes.func,
	setPre: PropTypes.func,
};
